module.exports = __webpack_public_path__ + "img/1522704686.4db7c92f.jpg";